import {
    DetailsList,
    FontSizes,
    FontWeights,
    Icon,
    IconButton,
    SelectionMode,
    Stack,
    TooltipHost
} from "@fluentui/react";
import * as React from "react";
import {useContext} from "react";
import AuthContext from "../Services/AuthContext";
import {useParams} from "react-router-dom";

function ProjectTasks(props) {
    const [user] = useContext(AuthContext);
    const params = useParams();

    const formatComments = (item) => { return {onRenderContent: () => {
            if (item.comments === null) {
                return null;
            }
            const comment = item.comments.split('###').map((item) => (<li>{item}</li>));
            return (
                <ol style={{ margin: 15, padding: 0 }}>
                    {comment}
                </ol>)
        }}}

    const columns = [
        {
            key: 'description',
            name: 'Opis',
            ariaLabel: 'Opis',
            fieldName: 'description',
            minWidth: 200,
            isResizable: true,
            isRowHeader: true,
        },
        {
            key: 'type',
            name: 'Typ',
            ariaLabel: 'Typ',
            fieldName: 'type',
            minWidth: 90,
            maxWidth: 150,
            isResizable: true,
        },
        {
            key: 'comment',
            name: 'Komentarze',
            ariaLabel: 'Komentarze',
            fieldName: 'comment',
            minWidth: 60,
            isResizable: false,
            onRender: (item) => (<TooltipHost tooltipProps={formatComments(item)}><Icon iconName={'Comment'} /></TooltipHost>)
        },
        {
            key: 'created',
            name: 'Utworzono',
            ariaLabel: 'Utworzono',
            fieldName: 'created',
            minWidth: 120,
            isResizable: false,
            isSorted: true
        },
        {
            key: 'in_progress',
            name: 'Przekazano',
            ariaLabel: 'Przekazano',
            fieldName: 'in_progress',
            minWidth: 120,
            isResizable: false,
        },
        {
            key: 'done',
            name: 'Zamknięto',
            ariaLabel: 'Zamknięto',
            fieldName: 'done',
            minWidth: 120,
            isResizable: false,
        },
        {
            key: 'rejected',
            name: 'Odrzucono',
            ariaLabel: 'Odrzucono',
            fieldName: 'rejected',
            minWidth: 80,
            isResizable: false,
        },
    ];

    if (props.data.length) {
        return (<Stack.Item>
            <h2 style={{fontSize: FontSizes.size24, fontWeight: FontWeights.light}}>
                {props.title}
                <a href={`/api/report/project/${params.id}/tasks?auth=${user.token}`} target={'_blank'} rel="noreferrer">
                    <IconButton iconProps={{iconName: 'PDF'}} title='PDF'/></a>
            </h2>
            <DetailsList items={props.data} columns={columns} selectionMode={SelectionMode.none}/>
        </Stack.Item>);
    }
    return null;
}

ProjectTasks.defaultProps = {
    title: 'Zadania'
}

export default ProjectTasks;